import { 
  TruckIcon,
  GlobeAltIcon,
  ArrowUturnLeftIcon,
  CurrencyDollarIcon,
  SparklesIcon,
  BuildingStorefrontIcon,
  CreditCardIcon
} from '@heroicons/react/24/outline';

function Process() {
  const services = [
    {
      title: 'Cross Border Logistics',
      description: 'Seamless international shipping with customs clearance, documentation handling, and end-to-end tracking for efficient cross-border commerce.',
      icon: TruckIcon
    },
    {
      title: 'Local Fulfillment Worldwide',
      description: 'Strategic fulfillment centers across key markets ensuring fast delivery and optimal inventory distribution for your global operations.',
      icon: GlobeAltIcon
    },
    {
      title: 'Returns Management',
      description: 'Streamlined returns process with local collection points, automated refunds, and inventory reintegration to enhance customer satisfaction.',
      icon: ArrowUturnLeftIcon
    },
    {
      title: 'Multicurrency Payments',
      description: 'Support for multiple currencies with real-time exchange rates and automated reconciliation for seamless international transactions.',
      icon: CurrencyDollarIcon
    },
    {
      title: 'AI Sales Tools',
      description: 'Advanced AI-powered tools for market analysis, pricing optimization, and sales forecasting to maximize your revenue potential.',
      icon: SparklesIcon
    },
    {
      title: 'Marketplace Access',
      description: 'Automated integration with major global marketplaces, enabling rapid expansion and multichannel presence with centralized management.',
      icon: BuildingStorefrontIcon
    },
    {
      title: 'Local Payment Gateways',
      description: 'Integration with preferred local payment methods and gateways to provide familiar and trusted payment options for customers worldwide.',
      icon: CreditCardIcon
    }
  ];

  const FeaturedIcon = services[0].icon;

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base text-[#0049ac] font-semibold tracking-wide uppercase font-poppins">What We Do</h2>
          <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl font-poppins">
            Comprehensive E-commerce Solutions
          </p>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-600">
            End-to-end services to power your global e-commerce expansion
          </p>
        </div>

        <div className="mt-20 space-y-12">
          {/* Featured Service */}
          <div className="relative bg-gradient-to-r from-gray-50 to-gray-100 p-8 rounded-lg md:rounded-xl shadow-sm md:shadow-md hover:shadow-md md:hover:shadow-lg transition-all duration-300">
            <div className="flex flex-col md:flex-row md:items-center md:space-x-8">
              <div className="absolute -top-4 left-6 md:static md:-top-0 md:left-0 md:flex-shrink-0 mb-6 md:mb-0">
                <div className="rounded-lg md:rounded-xl bg-[#0049ac] p-3 md:p-4 inline-block">
                  <FeaturedIcon className="h-6 md:h-12 w-6 md:w-12 text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-semibold md:font-bold text-gray-900 mt-8 md:mt-0">
                  {services[0].title}
                </h3>
                <p className="mt-4 md:mt-0 md:text-lg text-gray-600 leading-relaxed md:max-w-3xl">
                  {services[0].description}
                </p>
              </div>
            </div>
          </div>

          {/* Remaining Services Grid */}
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {services.slice(1).map((service, index) => {
              const Icon = service.icon;
              return (
                <div
                  key={index}
                  className="relative bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1 duration-300 border border-gray-100"
                >
                  <div className="absolute -top-4 left-6">
                    <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                  <h3 className="mt-8 text-xl font-semibold text-gray-900">
                    {service.title}
                  </h3>
                  <p className="mt-4 text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 text-center">
            <a
              href="/contact"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-[#0049ac] hover:scale-105 transform transition-all duration-300 font-poppins"
            >
              Learn More About Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;